import type { ReactNode, RefObject } from 'react';
import { Button, Popover } from '@sorrem/ui';
import styles from './Callout.module.scss';

interface CalloutProps {
    open: boolean;
    /** What the callout points at. */
    anchorRef: RefObject<HTMLElement>;
    /** Preferred side of the anchor; flips when it doesn't fit. */
    placement?: 'top' | 'right' | 'bottom' | 'left';
    /** Hides it for now (see `useCallout`). */
    onClose: () => void;
    /** Opts out of it for good. */
    onDismiss: () => void;
    children: ReactNode;
}

/**
 * A first-time callout: a popover glowing gold, so it reads apart from an
 * informational one, pointing at what a new player needs to find. Text on
 * top, then Close and Don't show again. A click elsewhere doesn't dismiss it,
 * so playing on with it up (walking, fighting) keeps it.
 */
export function Callout({ open, anchorRef, placement = 'top', onClose, onDismiss, children }: CalloutProps): JSX.Element {
    return (
        <Popover open={open} anchorRef={anchorRef} placement={placement} className={styles.callout}>
            <div className={styles.body} role='status'>
                <p className={styles.text}>{children}</p>
                <div className={styles.actions}>
                    <Button variant='link' size='small' onClick={onClose}>Close</Button>
                    <Button variant='link' size='small' onClick={onDismiss}>Don&apos;t show again</Button>
                </div>
            </div>
        </Popover>
    );
}
